import i18n from '@signavio/i18n';
import { defaultStyle } from '@signavio/ui';
import { utils, variables } from '../styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Toggle({
  disabled,
  noLabel,
  onChange,
  readOnly,
  style,
  value,
  yesLabel
}) {
  /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
  return /*#__PURE__*/_jsx("div", {
    ...style,
    children: /*#__PURE__*/_jsxs("div", {
      ...style('container'),
      children: [/*#__PURE__*/_jsx("div", {
        ...style('yes'),
        "data-testid": "yes",
        onClick: () => {
          if (readOnly || disabled) {
            return;
          }
          if (value === true) {
            onChange(false);
            return;
          }
          onChange(true);
        },
        children: yesLabel || i18n('Yes')
      }), /*#__PURE__*/_jsx("div", {
        ...style('switch'),
        "data-testid": "switch",
        onClick: () => {
          if (readOnly || disabled) {
            return;
          }
          onChange(!value);
        }
      }), /*#__PURE__*/_jsx("div", {
        ...style('no'),
        "data-testid": "no",
        onClick: () => {
          if (readOnly || disabled) {
            return;
          }
          if (value === false) {
            onChange(true);
            return;
          }
          onChange(false);
        },
        children: noLabel || i18n('No')
      })]
    })
  });
}
/* eslint-enable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */

export const getModifiers = ({
  value
}) => ({
  '&yesSelected': value === true,
  '&noSelected': value === false,
  '&active': value === true || value === false,
  '&inactive': value !== true && value !== false
});
const styled = defaultStyle(({
  color,
  font
}) => ({
  overflow: 'hidden',
  fontSize: font.size.button,
  textAlign: 'center',
  textTransform: 'uppercase',
  container: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: '100%',
    height: variables.lineHeight.block,
    lineHeight: `${variables.lineHeight.block}px`,
    cursor: 'pointer'
  },
  yes: {
    position: 'absolute',
    top: 0,
    display: 'block',
    width: '50%'
  },
  no: {
    position: 'absolute',
    display: 'block',
    top: 0,
    width: '50%',
    left: '50%'
  },
  switch: {
    position: 'relative',
    zIndex: 1,
    height: variables.lineHeight.block,
    width: '50%',
    backgroundColor: 'white',
    ...utils.transition(['left', 'width'])
  },
  '&active': {
    yes: {
      backgroundColor: color.primary.base,
      color: utils.color(color.primary.base)
    },
    no: {
      backgroundColor: color.mono.lighter,
      color: utils.color(color.mono.lighter)
    }
  },
  '&inactive': {
    yes: {
      backgroundColor: color.primary.light,
      color: utils.color(color.primary.light)
    },
    no: {
      backgroundColor: color.primary.light,
      color: utils.color(color.primary.light)
    },
    switch: {
      position: 'absolute',
      width: 1,
      left: '50%'
    }
  },
  '&yesSelected': {
    switch: {
      left: '50%',
      ...utils.border('1px', 'solid', color.mono.lighter),
      ...utils.boxShadow('-2px', '0px')
    }
  },
  '&noSelected': {
    switch: {
      left: 0,
      ...utils.border('1px', 'solid', color.mono.lighter),
      ...utils.boxShadow('2px', '0px')
    }
  }
}), getModifiers);
export default styled(Toggle);